<template>
    <div>
        <div class="modal fade show" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Account:</h5>
                        <button type="button" class="close" @click="$emit('emitClose', 0)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="isLoading">
                            <div class="col-12"><Loader></Loader></div>
                        </div>
                        <div class="row" v-else-if="!showBtnCode">
                            <div class="form-group col-md-12">
                                <label>Organization Name:</label>
                                <input type="text" v-model="f.company_name" class="form-control" />
                            </div>
                            <div class="form-group col-md-12">
                                <label>Phone:</label>
                                <input type="text" v-model="f.phone" class="form-control" />
                            </div>
                            <div class="form-group col-md-12">
                                <label>Email:</label>
                                <input type="text" v-model="f.email" class="form-control" />
                            </div>
                            <div class="form-group col-md-12">
                                <label>Password:</label>
                                <input type="password" v-model="f.password" class="form-control" />
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="form-group col-md-12">
                                <label>SMS Code Verify:</label>
                                <input type="text" v-model="f.code" class="form-control" />
                            </div>
                        </div>
                        <div class="row" v-if="messageError!=null">
                            <div class="col-md-12">
                                <div class="alert alert-danger">
                                    {{ messageError }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" v-if="!showBtnCode" class="btn btn-primary" @click="getCode()">Save changes</button>
                        <button type="button" v-if="showBtnCode" class="btn btn-secondary" @click="showBtnCode=false">Back</button>
                        <button type="button" v-if="showBtnCode" class="btn btn-success" @click="saveform()">Verify</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/core/components/shared/LoaderProgress'
export default {
    components: {
        Loader,
    },
    data() {
        return {
            isLoading: false,
            showBtnCode: false,
            f: {
                resellerId: localStorage.getItem('resellerId'),
                company_name: null,
                phone: null,
                email: null,
                password: null,
                code: null,
            },
            messageError: null,
        };
    },
    methods: {
        getCode() {
            let t = this;
            t.isLoading = true
            t.messageError = null;
            let p = {
                url: 'r2/getCodeVerify',
                data: t.f
            };
            t.$store.dispatch('apiRest', p)
            .then((response) => {
                console.log(response)
                t.isLoading = false;
                if(response.status){
                    this.showBtnCode=true;
                }else{
                    t.messageError = response.msj;
                }
            })
            .catch((error) => {
                console.log(error);
                t.isLoading = false
                t.messageError = error.message;
            });
        },
        saveform() {
            let t = this;
            t.isLoading = true
            t.messageError = null;
            let p = {
                url: 'r2/createAccount',
                data: t.f
            };
            t.$store.dispatch('apiRest', p)
            .then((response) => {
                console.log(response)
                t.isLoading = false;
                if(response.status){
                    t.$emit('emitClose', 1);
                }else{
                    t.messageError = response.msj;
                }
            })
            .catch((error) => {
                console.log(error);
                t.isLoading = false
                t.messageError = error.message;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.form-group {
    position: relative;
    text-align: left;
    margin-bottom: 0.5rem;
}
</style>